
import Copy from '@/components/copy';

/**
 * @component Title
 *
 * @public
 */

export default {
  name: 'TitleComponent',
  components: { Copy },
  props: {
    type: {
      type: String,
      default: 'h1',
    },
  },
  computed: {
    copyType() {
      switch (this.type) {
        case 'h1':
          return 'large';
        case 'h2':
          return 'heading';
        case 'h3':
          return 'sub-heading';
        default:
          return 'bode';
      }
    },
  },
};
